import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgMediaComponent } from "./ng-media.component";
import { OverlayPanelModule } from "primeng/primeng";
import { FileDropModule } from "ngx-file-drop";
import { HttpModule } from "@angular/http";
import { NgPopupModule } from "../ng-popup/ng-popup.module";
import { NgMediaService } from "./ng-media.service";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        OverlayPanelModule,
        FileDropModule,
        HttpModule,
        NgPopupModule
    ],
    declarations: [
        NgMediaComponent
    ],
    providers: [
        NgMediaService
    ],
    exports: [
        NgMediaComponent
    ]
})
export class NgMediaModule {
}

